import React, { useState } from 'react';
import { css } from '@emotion/react';
import { theme } from '../../../../../domain/theme';
import { t } from '../../../../../domain/services/configService';
import { IconHamburger } from '../../../../Icon/IconHamburger';
import { HamburgerMenu } from '../../HamburgerMenu';
import { Actionable } from '../../../atoms/Actionable';
import { Modal } from '../../Modal';

const styles = {
  hamburgerIcon: css`
    height: 50px;
    display: grid;
    place-items: center;
    padding: ${theme.spacing.parse('0 $xs')};
    ${theme.mq.tablet} {
      padding: ${theme.spacing.parse('0 $s')};
    }
    border-left: 1px solid #f2f2f2;
    button {
      display: flex;
    }
    span {
      ${theme.font.family('boldWeb')};
      font-size: ${theme.font.size('s')};
      letter-spacing: ${theme.letterSpacing('base')};
      text-transform: uppercase;
      margin-right: ${theme.spacing('xs2')};
      ${theme.mq.small_desktop} {
        display: none;
      }
    }
  `
};

export const HamburgerMenuItem = () => {
  const [isMenuExpanded, setMenuExpanded] = useState(false);
  const openHamburger = () => setMenuExpanded(true);
  const closeHamburger = () => setMenuExpanded(false);

  return (
    <>
      <div css={styles.hamburgerIcon} title={t('Menu')}>
        <Actionable title={t('View menu')} onClick={openHamburger}>
          <IconHamburger size={18} />
        </Actionable>
      </div>
      <Modal show={isMenuExpanded} overlayColor="#000" closeCb={closeHamburger}>
        <HamburgerMenu closeCb={closeHamburger} />
      </Modal>
    </>
  );
};
